import { isDevMode, isLocalHost } from '../utils/AppEnv';
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getFunctions } from 'firebase/functions';
import { getAnalytics } from 'firebase/analytics';
import { getStorage } from 'firebase/storage';
import { getRemoteConfig } from 'firebase/remote-config';
import { getDatabase } from 'firebase/database';

const localConfig = {
    apiKey: 'AIzaSyBDUnNJCLRZAp9_VHzTfTTGU37j6Mjf07s',
    authDomain: 'phio-dev-c5d2d.firebaseapp.com',
    databaseURL: 'https://phio-dev-c5d2d.firebaseio.com',
    projectId: 'phio-dev-c5d2d',
    storageBucket: 'phio-dev-c5d2d.appspot.com',
    messagingSenderId: '831737646743',
    appId: '1:831737646743:web:24debf76e0470679',
    measurementId: 'G-M6N1FSPCZ7'
};

const stageConfig = {
    apiKey: 'AIzaSyA9pOswwGAtpQEsUezRGBI92NctDuRQzuA',
    authDomain: 'phio-dev-c5d2d.firebaseapp.com',
    databaseURL: 'https://phio-dev-c5d2d.firebaseio.com',
    projectId: 'phio-dev-c5d2d',
    storageBucket: 'phio-dev-c5d2d.appspot.com',
    messagingSenderId: '831737646743',
    appId: '1:831737646743:web:24debf76e0470679',
    measurementId: 'G-M6N1FSPCZ7'
};

export const prodConfig = {
    apiKey: 'AIzaSyBhBIFb2tF82x0YWa6TmkspA7khQS0Udw0',
    authDomain: 'phio-main.firebaseapp.com',
    databaseURL: 'https://phio-main.firebaseio.com',
    projectId: 'phio-main',
    storageBucket: 'phio-main.appspot.com',
    messagingSenderId: '269752456677',
    appId: '1:269752456677:web:9584326099de318a',
    measurementId: 'G-9KRV02FYP4'
};

const getEnvironmentTier = (url: string): 'local' | 'staging' | 'prod' => {
    if (isLocalHost(url)) return 'local';
    if (isDevMode(url)) return 'staging';
    return 'prod';
};

const configs = {
    local: localConfig,
    staging: stageConfig,
    prod: prodConfig
};

const tier = getEnvironmentTier(window.location.href);
export const app = initializeApp(configs[tier]);
export const auth = getAuth(app);

export const firestoreInstance = (databaseId?: string) => {
    if (databaseId) {
        window.localStorage.setItem('fid', databaseId);
    }
    const prev = window.localStorage.getItem('fid') ?? '(default)';
    return getFirestore(app, databaseId ?? prev);
};
export const realtimedb = getDatabase(app);
export const functions = getFunctions(app);
export const analytics = getAnalytics(app);
export const storage = getStorage(app);
const remoteConfig = getRemoteConfig(app);
remoteConfig.settings.minimumFetchIntervalMillis = 3600000;
export { remoteConfig };
